<template>
    <div>
        <v-select
            ref="vselectSearchGroup"
            :options="options"
            :value="value"
            :selectOnTab="true"
            :filter="filter"
            @search="onSearch"
            @input="onInput"
            @search:blur="onBlur"
            @search:focus="onFocus"
            placeholder="First Name (required)"
        >
            <template slot="no-options">
                <span></span>
            </template>
            <template slot="option" slot-scope="option">
                <strong>{{ option.label }}</strong>
                <div v-if="option.email">E: {{ option.email }}</div>
            </template>
        </v-select>
    </div>
</template>
<style lang="scss">
@import "@/scss/helper.scss";
#firstname > div > div.vs__selected-options > input {
    opacity: 1;
}
</style>
<script type="text/javascript">
import vSelect from "vue-select";
import { debounce, has, concat, isEmpty } from "lodash";
import Client from "@/services/client";

export default {
    components: {
        vSelect
    },
    props: {
        value: {}
    },
    data() {
        return {
            query: "",
            selected: "",
            options: []
        };
    },
    methods: {
        filter(options, search) {
            return options;
        },
        onSearch(value) {
            this.query = value;
            if (!value) {
                return;
            }

            this.fetchOptions(value, this);
        },
        fetchOptions: debounce(async (value, self) => {
            const res = await Client.getClientByGroupCompany(value);
            if (res.message.code === 200) {
                self.options = concat({ label: value }, res.resource);
            } else {
                self.options = [{ label: value }];
            }
        }, 350),
        onInput(value) {
            this.selected = value;

            if (_.isObject(value)) {
                if (has(value, "firstname")) {
                    this.$emit("input", value.firstname);
                    this.$emit("update", value);
                } else {
                    this.$emit("input", value.label);
                }
            } else {
                this.$emit("input", value);
            }
        },
        onFocus() {
            this.selected = "";
        },
        onBlur() {
            if (isEmpty(this.selected)) {
                this.$emit("input", this.query);
            }
        }
    }
};
</script>
